// @ts-ignore
import mixpanel from 'mixpanel-browser';
import { track } from '@vercel/analytics';
import {getUserExperimentId} from "./ExpirmentHelper";

declare global {
    interface Window {
        dataLayer: any[];
    }
}

const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN;

if (mixpanelToken) {
    mixpanel.init(
        mixpanelToken,
        {
            debug: process.env.REACT_APP_MIXPANEL_DEBUG === 'true',
            track_pageview: true,
            persistence: 'localStorage',
        }
    );
}

export const TRACKING_EVENTS = {
    // General Navigating
    PAGE_NAVIGATION: {
        event: 'page_navigation',
        value: 1,
        currency: 'USD',
        category: 'navigation',
        content_type: 'navigation'
    },
    CATEGORY_CLICKED: {
        event: 'home_category_clicked',
        value: 1.5,
        currency: 'USD',
        category: 'content_engagement'
    },
    HIGHLIGHT_SECTION_CLICKED: {
        event: 'highlight_section_clicked',
        value: 1.5,
        currency: 'USD',
        category: 'content_engagement'
    },

    // Clicking content
    CONTENT_ITEM_CLICKED: {
        event: 'content_item_clicked',
        value: 3,
        currency: 'USD',
        category: 'content_engagement'
    },
    DETAIL_ITEM_CLICKED: {
        event: 'detail_item_clicked',
        value: 3,
        currency: 'USD',
        category: 'content_engagement'
    },
    DISCORD_JOIN_CLICKED: {
        event: 'discord_join_clicked',
        value: 10,
        currency: 'USD',
        category: 'community_engagement'
    },

    // Interest in signing up
    REGISTER_CLICKED: {
        event: 'register_clicked',
        value: 5,
        currency: 'USD',
        category: 'user_actions'
    },
    LOGIN_CLICKED: {
        event: 'login_clicked',
        value: 5,
        currency: 'USD',
        category: 'user_actions'
    },

    // New Sign Up
    NEW_USER_SIGNS_UP: {
        event: 'user_signup',
        value: 25,
        currency: 'USD',
        category: 'user_actions'
    },

    // Signed up and completing content
    LESSON_COMPLETED: {
        event: 'lesson_completed',
        value: 15,
        currency: 'USD',
        category: 'content_completed'
    },
    CHALLENGE_COMPLETED: {
        event: 'challenge_completed',
        value: 15,
        currency: 'USD',
        category: 'content_completed'
    },

    // Starting a New Trial
    PREMIUM_CLICKED: {
        event: 'premium_clicked',
        value: 20,
        currency: 'USD',
        category: 'user_actions'
    },
    TRIAL_STARTED: {
        event: 'user_start_free_trial',
        value: 70,
        currency: 'USD',
        category: 'conversions'
    },
    PREMIUM_UPGRADE: {
        event: 'user_trial_successfully_started',
        value: 150,
        currency: 'USD',
        category: 'conversions'
    },
    
    // Onboarding Flow
    ONBOARDING_STARTED: {
        event: 'onboarding_started',
        value: 5,
        currency: 'USD',
        category: 'onboarding'
    },
    ONBOARDING_QUESTION_ANSWERED: {
        event: 'onboarding_question_answered',
        value: 10,
        currency: 'USD',
        category: 'onboarding'
    },
    ONBOARDING_COMPLETED: {
        event: 'onboarding_completed',
        value: 50,
        currency: 'USD',
        category: 'onboarding'
    },
    ONBOARDING_SKIPPED: {
        event: 'onboarding_skipped',
        value: 2,
        currency: 'USD',
        category: 'onboarding'
    },
} as const;

export function trackEvent(
    baseEvent: typeof TRACKING_EVENTS[keyof typeof TRACKING_EVENTS],
    additionalParams: Record<string, any> = {}
): void {
    const eventData = {
        ...baseEvent,
        timestamp: new Date().toISOString(),
        experimentId: getUserExperimentId(),
        ...additionalParams
    };
    
    try {
        // Mixpanel
        mixpanel.track(eventData.event, {
            category: eventData.category,
            value: eventData.value,
            currency: eventData.currency,
            timestamp: eventData.timestamp,
            ...additionalParams
        });

        // Vercel
        if (process.env.REACT_APP_VERCEL_TRACKING_ENABLED === "true") {
            track(eventData.event, additionalParams);
        }

        // GTM
        if (typeof window !== 'undefined') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(eventData);
            console.log('✅ GTM Event pushed:', eventData);
        }
        
        console.log('✅ Event tracked across all platforms:', eventData.event, additionalParams);
    } catch (error) {
        console.error('❌ Error tracking event:', error);
    }
}


export function setupMixpanel(currentUser: any) {
    mixpanel.identify(currentUser.uid);
    mixpanel.people.set({'$email': currentUser.email, 'experimentId': getUserExperimentId()})
}

export function resetMixpanel() {
    mixpanel.reset();
}
